const RecycleTypeItems = Object.freeze(
  [
    { id: 0, name: 'リサイクル', value: 'Recycle', color: "#71B6E8" },
    { id: 1, name: '単純リユース', value: 'SimpleReuse', color: "#237E9D" },
    { id: 2, name: 'クリエイティブ', value: 'CreativeReuse', color: "#6BDBD1" },
    { id: 3, name: 'ケミカルリサイクル', value: 'ChemicalRecycle', color: "#4DB8AD" },
    { id: 4, name: 'マテリアルリサイクル', value: 'MaterialRecycle', color: "#4DB380" },
    { id: 5, name: 'サーマルリサイクル', value: 'ThermalRecycle', color: "#F8735D" },
    { id: 6, name: '焼却後リサイクル', value: 'AfterIncinerationRecycle', color: "#CD87DC" },
    { id: 7, name: '単純焼却', value: 'Incineration', color: "#F0A6CE" },
    { id: 8, name: '埋立', value: 'Landfill', color: "#F2A79D" }
  ]
)

export default RecycleTypeItems
